import { AssignmentTurnedIn, FactCheck, Favorite, Fingerprint, Login, Logout, Timeline } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import moment from 'moment/moment';

import { useAlert } from '../../../../context/AlertContext';
import CalculateHours from '../../../../components/CalculateHours';
import useGeolocation from '../../../../hooks/useGeolocation';
import LocationTroubleshoot from '../../../../components/LocationTroubleshoot';
import { useAuth } from '../../../../context/AuthContext';
import essPunchServices from '../essPunchServices';
import { useAppData } from '../../../../context/AppDataContext';
import { useEssAppData } from '../../../../context/AppESSDataContext';

function EssPunch() {

    const {AppAlert} = useAlert();
    const {companyLocationDD,getDDDataById} = useAppData();
    const { workLocation,employeeDetails } = useEssAppData();
    const [saving,setSavingStatus] = useState(false);
    const [loading,setLoadingStatus] = useState(false);
    const [dialogStatus,setDialogStatus] = useState(false);

    const {authUser } = useAuth();

    const [lastPunch,setPunchDetails] = useState(null);

    const [distance,setDistance] = useState(null);
    

    const { getLocation, locatingLoading, geoLocationError,location } = useGeolocation();

    const getLastPunch = () =>{
        setLoadingStatus(true);
        essPunchServices.getLastPunch().then(res=>{
            console.log("Here in get punch details",res.data);
            setPunchDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const handlePunch = async () => {
        setSavingStatus(true);

        if (!workLocation || !workLocation.lat || !workLocation.lng) {
            AppAlert("Work location configuration is missing.", "error");
            setSavingStatus(false);
            return;
        }

        // 1. Get the fresh location directly from the promise resolution
        const coords = await getLocation();

        if (!coords) {
            // If location retrieval failed or was denied, getLocation already handled the error message
            setSavingStatus(false);
            return;
        }

        // 2. Calculate the distance locally using the fresh coordinates
        let calculatedDistance = essPunchServices.getDistanceInMeters(
            { lat: workLocation.lat, lng: workLocation.lng },
            coords
        );

        // Update state so UI components (like the dialog) can also read it if needed
        setDistance(calculatedDistance);

        let punchStatus = 0;

        // 3. Validate against the freshly calculated distance
        if (calculatedDistance === null || calculatedDistance > workLocation.radious) {
            if(employeeDetails.allowRemotePunch == 0){
                AppAlert("You are not at your work location", "error");
                setSavingStatus(false);
                return; 
            }
        } else {
            punchStatus = 1;
        }
        
        const formData = new FormData();
        formData.append('lat', parseFloat(coords.lat.toFixed(6)));
        formData.append('lng', parseFloat(coords.lng.toFixed(6)));
        formData.append('punchStatus', punchStatus);

        if (lastPunch) {
            formData.append('id', lastPunch.id);
            formData.append('inTime', lastPunch.inTime);
        }

        essPunchServices.addPunch(formData).then(res => {
            AppAlert(res.msg);
        }).catch(error => {
            AppAlert(error.msg, "error");
        }).finally(() => {
            getLastPunch();
            setDialogStatus(false);
            setTimeout(() => {
                setSavingStatus(false);
            }, 1000);
        });
    };


    useEffect(()=>{
        getLastPunch();
    },[])


    


    

    

    return (
        <>
                <Dialog
                    open={dialogStatus}
                    keepMounted
                    onClose={()=>setDialogStatus(false)}
                    maxWidth="sm"
                >   
                    {!geoLocationError && 
                    <>  
                        <DialogTitle>Attendance</DialogTitle>
                        {JSON.stringify(employeeDetails.all)}
                        <DialogContent>
                            Confirm <span className="fw-bold">{!lastPunch ? "Check In" : "Check Out"}</span> for today. Your current location will be recorded for attendance purposes.
                            <br/>
                            <br/>
                            { 
                                distance && distance > workLocation?.radious && employeeDetails.allowRemotePunch == 0 &&
                                    <div className="alert alert-danger" role="alert">
                                        <h4 className="alert-heading">Error</h4>
                                        <p> You are {distance / 1000} KM Away from your work Location </p>

                                        <p> You are should be around {workLocation.radious} meter away from your work location</p>
                                        <hr/>
                                        Punch Not Allowed
                                    </div>
                            }
                        </DialogContent>
                        
                        
                        <DialogActions>
                            {!lastPunch ? 
                                <button className='btn btn-primary' disabled={saving} onClick={handlePunch}>Yes Check In</button>
                                :
                                <button className='btn btn-primary' disabled={saving} onClick={handlePunch}>Yes Check Out</button>
                            }
                            <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)}>No</button>
                        </DialogActions>
                        
                    </>
                    }

                    
                    {geoLocationError && 
                    <DialogContent>
                        <div className="alert alert-danger" role="alert">
                            <h4 className="alert-heading">Error</h4>
                                <p>{geoLocationError} - <button className='btn btn-danger' onClick={getLocation}>Retry</button></p>
                            <hr/>
                            <LocationTroubleshoot/>
                        </div>
                    </DialogContent>
                    }
                </Dialog>
            


                <div className='row'>                
                    {saving &&
                        <button className='btn btn-success text-white'   >
                            <CircularProgress className='text-white' />
                        </button>
                    }
                    { (!saving && !lastPunch) ?
                            <button 
                                    onClick={() => setDialogStatus(true)} 
                                    className='btn btn-purple purple-glow' 
                                    style={{ borderRadius: '15px'}}
                                >
                                    <div className='d-flex align-items-center'>
                                        <div className="me-3">
                                            <Fingerprint style={{fontSize:40, color:"#0F0" }}/>
                                        </div>

                                        <div className='text-start'>
                                            <div style={{ fontWeight: '800', letterSpacing: '1px', fontSize: '16px' }}>
                                                MARK ATTENDANCE
                                            </div>
                                            <hr className='devider m-0'/>
                                            <div style={{ fontSize: 12, opacity: 0.9 }}>
                                                PUNCH IN FOR TODAY
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            
                            
                        :
                        <>
                            {lastPunch &&  lastPunch?.outTime ==null &&
                                <button 
                                    onClick={() => setDialogStatus(true)} 
                                    className='btn btn-light-purple purple-glow' 
                                    style={{ borderRadius: '15px'}}
                                >
                                    <div className='d-flex align-items-center'>
                                        <div className="me-3">
                                            <Timeline className='text-success' style={{fontSize:40 }} />
                                        </div>

                                        <div className='text-start '>
                                            <div className='blink-infinite' style={{ fontWeight: '800', letterSpacing: '1px', fontSize: '16px' }}>
                                                ON DUTY <span className="fw-bold"><CalculateHours inTime={lastPunch.inTime} /></span>
                                            </div>
                                            <hr className='devider m-0'/>
                                            <div style={{ fontSize: 12, opacity: 0.9 }}>
                                                In: {moment(lastPunch.inTime).format("HH:mm")}
                                                {!lastPunch.outTime && (
                                                    <span className="live-indicator" style={{ marginLeft: '8px' }}>● Live</span>
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <span className='bg-orange  p-1 ms-2 rounded'>PUNCH OUT</span>
                                        </div>
                                    </div>
                                </button>
                            }


                            {lastPunch && lastPunch?.outTime !== null &&
                                <button 
                                    className='btn btn-light-purple shadow' 
                                    style={{ borderRadius: '15px'}}
                                >
                                    <div className='d-flex align-items-center'>
                                        <div className="me-3">
                                            <AssignmentTurnedIn className='text-success' style={{fontSize:40  }} />
                                        </div>

                                        <div className='text-start '>
                                            <div style={{ fontWeight: '800', letterSpacing: '1px', fontSize: '16px' }}>
                                                SHIFT COMPLETED <span className="fw-bold"><CalculateHours inTime={lastPunch.inTime} outTime={lastPunch.outTime} /></span>
                                            </div>
                                            <hr className='devider m-0'/>
                                            <div className='fw-bold' style={{ fontSize: 12, opacity: 0.9 }}>
                                                <span >IN: {moment(lastPunch.inTime).format("HH:mm")} - </span>
                                                <span >OUT: {moment(lastPunch.outTime).format("HH:mm")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            }
                        </>
                        
                    }
                </div>
            
            
        </>
    )
}

export default EssPunch